import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { GisBoqWorkbenchService } from 'src/app/shared/services/gis-boq-workbench.service';
import { BoqExplorerNode } from './gis-boq-explorer.model';

@Component({
  selector: 'app-gis-boq-explorer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gis-boq-explorer.component.html',
  styleUrls: ['./gis-boq-explorer.component.css'],
})
export class GisBoqExplorerComponent implements OnInit, OnDestroy {
  private sub?: Subscription;

  constructor(readonly wb: GisBoqWorkbenchService) {}

  ngOnInit(): void {
    this.sub = this.wb.state$.subscribe();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  isOn(id: string): boolean {
    return this.wb.checked[id] !== false;
  }

  isExpanded(id: string): boolean {
    return this.wb.expanded[id] !== false;
  }

  toggleExpand(node: BoqExplorerNode, ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();
    if (node.children?.length) this.wb.toggleExpanded(node.id);
  }

  onCheck(id: string, ev: Event): void {
    const el = ev.target as HTMLInputElement;
    this.wb.toggleNode(id, el.checked);
  }
}
